<template>
  <div class="columns query" v-if="Object.keys(query).length > 0">
    <div class="column">
      <div class="field">
        <template v-for="(v, k) in query">
          <template v-if="Array.isArray(v)">
            <template v-for="(v, i) in v">
              <div class="tags has-addons" v-if="v != null" :key="v.toString() + i">
                <span class="tag is-success">{{k}}</span>
                <span class="tag is-warning">=</span>
                <span class="tag is-info">{{v}}</span>
              </div>
              <button
                class="delete"
                aria-label="delete"
                :key="v.toString() + i + '.btn'"
                @click="remove(query[k], i)"
              ></button>
            </template>
          </template>
          <template v-else-if="v != null">
            <div class="tags has-addons" :key="k">
              <span class="tag is-success">{{k}}</span>
              <span class="tag is-warning">=</span>
              <span class="tag is-info">{{v}}</span>
            </div>
            <button class="delete" aria-label="delete" :key="v" @click="remove(query, k)"></button>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QueryPreview",
  props: {
    query: { type: Object }
  },
  methods: {
    remove: function(obj, k) {
      this.$delete(obj, k);
      for (let k in this.query) {
        if (Array.isArray(this.query[k]) && this.query[k].length == 1) {
          this.query[k] = this.query[k][0];
        }
      }
    }
  }
};
</script>

<style scoped>
.query .tags {
  display: inline-block;
  margin-bottom: 0rem;
}
.query button.delete {
  margin: 3px 3px 0 3px;
}
</style>
